<template>
    <div class="soc-wrap">
        <a v-if="!whatsappOnly" :href="linkedIn" target="_blank" :class="classList" class="soc-link-bgl hide-in-mobile">
            <svg :fill="fill" :height="size || 30" :width="size || 30" version="1.1" id="Layer_1"
                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 310 310"
                xml:space="preserve">
                <g id="XMLID_801_">
                    <path id="XMLID_802_" d="M72.16,99.73H9.927c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5H72.16c2.762,0,5-2.238,5-5V104.73
         C77.16,101.969,74.922,99.73,72.16,99.73z" />
                    <path id="XMLID_803_" d="M41.066,0.341C18.422,0.341,0,18.743,0,41.362C0,63.991,18.422,82.4,41.066,82.4
         c22.626,0,41.033-18.41,41.033-41.038C82.1,18.743,63.692,0.341,41.066,0.341z" />
                    <path id="XMLID_804_" d="M230.454,94.761c-24.995,0-43.472,10.745-54.679,22.954V104.73c0-2.761-2.238-5-5-5h-59.599
         c-2.762,0-5,2.239-5,5v199.928c0,2.762,2.238,5,5,5h62.097c2.762,0,5-2.238,5-5v-98.918c0-33.333,9.054-46.319,32.29-46.319
         c25.306,0,27.317,20.818,27.317,48.034v97.204c0,2.762,2.238,5,5,5H305c2.762,0,5-2.238,5-5V194.995
         C310,145.43,300.549,94.761,230.454,94.761z" />
                </g>
            </svg>
        </a>
        <a v-if="!whatsappOnly" :href="facebook" target="_blank" :class="classList" class="soc-link-bgl hide-in-mobile">
            <svg alt="Share on Facebook" class="soc-icon-bgl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                :width="size || 30" :height="size || 30">
                <path :fill="fill"
                    d="M17.525,9H14V7c0-1.032,0.084-1.682,1.563-1.682h1.868v-3.18C16.522,2.044,15.608,1.998,14.693,2 C11.98,2,10,3.657,10,6.699V9H7v4l3-0.001V22h4v-9.003l3.066-0.001L17.525,9z" />
            </svg>
        </a>
        <a v-if="!whatsappOnly" :href="email" target="_blank" :class="classList" class="soc-link-bgl hide-in-mobile">
            <svg class="soc-icon-bgl" alt="Email" :width="size || 30" :height="size || 30" viewBox="0 0 90 64"
                version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path
                        d="M58.592509,35.6790946 L86.912509,63.9997186 L3.669373,63.9997186 L31.669373,35.9997186 L33.804381,37.9653442 C39.952317,43.6268258 49.961405,43.6269346 56.109373,37.9653442 L58.592509,35.6790946 Z M0.199997,7.0197186 L28.135613,32.744717 L0.199997,60.6803426 L0.199997,7.0197186 Z M89.799997,6.9409666 L89.799997,60.0984674 L62.126237,32.424717 L89.799997,6.9409666 Z M89.799997,-0.0002814 L89.799997,0.4272194 L52.573117,34.7084834 C48.323453,38.6218754 41.591549,38.621149 37.341885,34.7078434 L0.199997,0.504717 L0.199997,-0.0002814 L89.799997,-0.0002814 Z"
                        id="Combined-Shape" :fill="fill" fill-rule="nonzero"></path>
                </g>
            </svg>
        </a>

        <a v-if="!whatsappOnly" :href="twitter" target="_blank" :class="classList" class="soc-link-bgl hide-in-mobile">
            <svg alt="Share on Twitter" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2122 2122"
                style="enable-background:new 0 0 2122 2122;" xml:space="preserve">
                <g>
                    <g>
                        <path fill="white" d="M1569.6,1544.8l-398-578.3l-45-65.4L841.9,487.5l-23.6-34.3H468.4l85.3,124l378.6,550.1l45,65.3l304.2,442l23.6,34.2H1655
			L1569.6,1544.8z M1346.7,1589.7l-316-459.2l-45-65.4L619,532.3h157.7l296.6,430.9l45,65.4l386.2,561.1H1346.7z" />
                        <polygon fill="white"
                            points="985.7,1065.1 1030.7,1130.5 977.3,1192.6 568,1668.8 467,1668.8 932.3,1127.3 		" />
                        <polygon fill="white"
                            points="1612.8,453.2 1171.6,966.5 1118.3,1028.6 1073.2,963.2 1126.6,901.1 1425.5,553.2 1511.9,453.2 		" />
                    </g>
                </g>
            </svg>
        </a>
        <a v-if="!whatsappOnly && this.vendor == ''" :href="whatsapp" target="_blank" :class="classList"
            class="soc-link-bgl hide-in-mobile">
            <svg alt="Share on Whatsapp" class="soc-icon-bgl" :width="size || 30" :height="size || 30"
                viewBox="0 0 800 800" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path
                        d="M407.101299,0 C623.748052,0 800,174.945455 800,389.981818 C800,604.994805 623.748052,779.922078 407.103896,779.919481 C342.127273,779.919481 277.924675,763.898701 221.119481,733.548052 L13.5350649,799.511688 C12.5012987,799.841558 11.4415584,800 10.3896104,800 C7.64415584,800 4.95584416,798.909091 2.97402597,796.885714 C0.228571429,794.090909 -0.706493506,789.987013 0.550649351,786.275325 L68.038961,587.197403 C32.7792208,527.612987 14.1662338,459.532468 14.1662338,389.981818 C14.1662338,174.945455 190.436364,0 407.101299,0 Z M407.098701,81.2363636 C235.483117,81.2363636 95.8623377,219.74026 95.8623377,389.981818 C95.8623377,455.415584 116.353247,517.994805 155.116883,570.961039 C157.116883,573.693506 157.65974,577.228571 156.574026,580.433766 L123.005195,679.47013 L226.992208,646.415584 C228.023377,646.088312 229.083117,645.927273 230.14026,645.927273 C232.14026,645.927273 234.127273,646.503896 235.838961,647.628571 C286.742857,681.031169 345.961039,698.685714 407.101299,698.685714 C578.698701,698.685714 718.298701,560.202597 718.298701,389.981818 C718.298701,219.74026 578.693506,81.2363636 407.098701,81.2363636 Z M300.750649,206.877922 C312.311688,206.877922 320.631169,213.893506 326.927273,228.961039 C329.545455,235.205195 354.171429,294.638961 355.550649,297.397403 C357.231169,300.693506 362.431169,310.901299 356.342857,322.997403 L355.036364,325.623377 C352.542857,330.677922 350.392208,335.041558 345.561039,340.662338 C344.01039,342.454545 342.431169,344.355844 340.854545,346.254545 C337.524675,350.262338 334.083117,354.405195 330.906494,357.548052 C329.820779,358.636364 327.716883,360.745455 327.488312,361.584416 L327.491617,361.600832 C327.509616,361.716083 327.615923,362.441671 328.464935,363.888312 C334.976623,374.909091 382.464935,440.262338 445.028571,467.438961 C447.761039,468.625974 456.787013,472.342857 457.309091,472.342857 C457.890909,472.342857 458.862338,471.371429 459.574026,470.558442 C465.023377,464.4 482.65974,443.784416 488.485714,435.124675 C493.638961,427.415584 500.254545,423.490909 508.12987,423.490909 C512.950649,423.490909 517.483117,424.974026 521.714286,426.493506 C532.077922,430.223377 590.4,458.942857 591.958442,459.690909 C599.597403,463.358442 605.631169,466.254545 609.132468,472.01039 C614.244156,480.475325 612.218182,503.8 604.535065,525.148052 C594.781818,552.251948 551.903896,574.47013 532.392208,576.2 L529.52987,576.472727 C525.018182,576.916883 519.903896,577.418182 513.514286,577.418182 C498.306494,577.418182 471.561039,574.81039 415.080519,552.249351 C356.412987,528.812987 298.54026,478.568831 252.116883,410.771429 C251.314286,409.597403 250.761039,408.779221 250.45974,408.376623 C238.337662,392.4 210.103896,350.392208 210.103896,305.901299 C210.103896,256.467532 233.766234,228.358442 247.753247,219.54026 C260.942857,211.225974 290.774026,207.298701 296.251948,207.067532 C299.381479,206.93563 299.814818,206.895485 300.149841,206.883267 L300.21214,206.881288 L300.27594,206.87987 C300.297879,206.87948 300.320704,206.879169 300.345046,206.878919 L300.514402,206.878047 C300.530879,206.878016 300.548053,206.877992 300.566003,206.877975 Z"
                        id="Combined-Shape" :fill="fill" fill-rule="nonzero"></path>
                </g>
            </svg>
        </a>

        <!-- green whatsapp icon -->
        <a v-if="(whatsappOnly && phoneForWhatsapp && !isUS()) || this.vendor != ''"
            :href="whatsapp" target="_blank" :class="classList" class="soc-link-bgl clickableScale no-background">
            <img src="../assets/whatsapp.png">

            <svg alt="Chat on Whatsapp" class="soc-icon-bgl" :width="size || 30" :height="size || 30"
                viewBox="0 0 800 800" version="1.1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink">
                <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                    <path
                        d="M407.101299,0 C623.748052,0 800,174.945455 800,389.981818 C800,604.994805 623.748052,779.922078 407.103896,779.919481 C342.127273,779.919481 277.924675,763.898701 221.119481,733.548052 L13.5350649,799.511688 C12.5012987,799.841558 11.4415584,800 10.3896104,800 C7.64415584,800 4.95584416,798.909091 2.97402597,796.885714 C0.228571429,794.090909 -0.706493506,789.987013 0.550649351,786.275325 L68.038961,587.197403 C32.7792208,527.612987 14.1662338,459.532468 14.1662338,389.981818 C14.1662338,174.945455 190.436364,0 407.101299,0 Z M407.098701,81.2363636 C235.483117,81.2363636 95.8623377,219.74026 95.8623377,389.981818 C95.8623377,455.415584 116.353247,517.994805 155.116883,570.961039 C157.116883,573.693506 157.65974,577.228571 156.574026,580.433766 L123.005195,679.47013 L226.992208,646.415584 C228.023377,646.088312 229.083117,645.927273 230.14026,645.927273 C232.14026,645.927273 234.127273,646.503896 235.838961,647.628571 C286.742857,681.031169 345.961039,698.685714 407.101299,698.685714 C578.698701,698.685714 718.298701,560.202597 718.298701,389.981818 C718.298701,219.74026 578.693506,81.2363636 407.098701,81.2363636 Z M300.750649,206.877922 C312.311688,206.877922 320.631169,213.893506 326.927273,228.961039 C329.545455,235.205195 354.171429,294.638961 355.550649,297.397403 C357.231169,300.693506 362.431169,310.901299 356.342857,322.997403 L355.036364,325.623377 C352.542857,330.677922 350.392208,335.041558 345.561039,340.662338 C344.01039,342.454545 342.431169,344.355844 340.854545,346.254545 C337.524675,350.262338 334.083117,354.405195 330.906494,357.548052 C329.820779,358.636364 327.716883,360.745455 327.488312,361.584416 L327.491617,361.600832 C327.509616,361.716083 327.615923,362.441671 328.464935,363.888312 C334.976623,374.909091 382.464935,440.262338 445.028571,467.438961 C447.761039,468.625974 456.787013,472.342857 457.309091,472.342857 C457.890909,472.342857 458.862338,471.371429 459.574026,470.558442 C465.023377,464.4 482.65974,443.784416 488.485714,435.124675 C493.638961,427.415584 500.254545,423.490909 508.12987,423.490909 C512.950649,423.490909 517.483117,424.974026 521.714286,426.493506 C532.077922,430.223377 590.4,458.942857 591.958442,459.690909 C599.597403,463.358442 605.631169,466.254545 609.132468,472.01039 C614.244156,480.475325 612.218182,503.8 604.535065,525.148052 C594.781818,552.251948 551.903896,574.47013 532.392208,576.2 L529.52987,576.472727 C525.018182,576.916883 519.903896,577.418182 513.514286,577.418182 C498.306494,577.418182 471.561039,574.81039 415.080519,552.249351 C356.412987,528.812987 298.54026,478.568831 252.116883,410.771429 C251.314286,409.597403 250.761039,408.779221 250.45974,408.376623 C238.337662,392.4 210.103896,350.392208 210.103896,305.901299 C210.103896,256.467532 233.766234,228.358442 247.753247,219.54026 C260.942857,211.225974 290.774026,207.298701 296.251948,207.067532 C299.381479,206.93563 299.814818,206.895485 300.149841,206.883267 L300.21214,206.881288 L300.27594,206.87987 C300.297879,206.87948 300.320704,206.879169 300.345046,206.878919 L300.514402,206.878047 C300.530879,206.878016 300.548053,206.877992 300.566003,206.877975 Z"
                        id="Combined-Shape" :fill="fill" fill-rule="nonzero"></path>
                </g>
            </svg>
        </a>

    </div>


</template>

<script>
import { getCountry } from "../utils/geolocation";

export default {
    props: {
        title: String,
        classList: String,
        size: Number,
        color: String,
        vendor: String,
        pagename: String,
        phoneForWhatsapp: String,
        whatsappOnly: { type: Boolean, default: false },
        shortCountry: {
            type: String,
            default : "US"
        }
    },
    created() {
        this.initData();
    },
    methods: {
        async initData() {
            this.shortCountry = await getCountry();
        },
        isUS() {
            return String(this.shortCountry).toLocaleLowerCase() == "us";
        }
    },
    computed: {
        fill() {
            return this.color || "black";
        },
        path() {
            return window.location.href;
        },
        whatsapp() {
            // TODO: move all these to Bagel
            if (this.phoneForWhatsapp) {
                return "https://api.whatsapp.com/send?phone=" + this.phoneForWhatsapp;
            }

            if (this.vendor == "" && !this.pagename) {
                let str = `https://api.whatsapp.com/send?text=${this.path}\n${this.title}`;
                return encodeURI(str);
            }
            else {
                if (this.pagename == "delivery")
                    return "https://api.whatsapp.com/send?phone=972545333556";
                else
                    return "https://api.whatsapp.com/send?phone=972585304304";
            }

        },
        facebook() {
            let str = `https://www.facebook.com/sharer.php?u=${this.path}&t=${this.title}`;
            return encodeURI(str);
        },
        linkedIn() {
            const str = `https://www.linkedin.com/shareArticle?url=${this.path}&title=${this.title}`;
            return str;
        },
        twitter() {
            let str = `https://twitter.com/intent/tweet?url=${this.path}&text=${this.title}`;
            return encodeURI(str);
        },
        email() {
            let str = `mailto:?subject=${this.title}&body=${this.path} \n${this.title}`;
            return encodeURI(str);
        },
    },
};
</script>

<style scoped>
.soc-link-bgl {
    margin-bottom: 15px;
    background-color: #2d3034;
    border-radius: 100%;
    height: 40px;
    width: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 2px solid white;
}

.whatsapp-only .soc-link-bgl {
    width: 80px;
    height: 80px;
    margin-bottom: 3px;
}

.soc-link-bgl:hover {
    background: #5c6168;
}

.soc-wrap {
    display: flex;
    flex-direction: column;
    z-index: 10;
}

.soc-icon-bgl {}

@media screen and (max-width: 767px) {
    .soc-wrap .hide-in-mobile {
        display: none;
    }

    .whatsapp-only .soc-link-bgl {
        width: 70px;
        height: 70px;
    }
}
</style>
